<template>
    <div>
        <!-- 菜单栏 -->
        <div class="flex flex-col items-center gap-4 py-6" style="background-color: #0D3B80">
            <div v-for="item in linkList" :key="item?.id"
                @click="() => handleNavigateToLink(item)"
                class="flex items-center gap-2 text-white font-extralight text-base">
                <img :src="'/mainsys/UserFiles/externalicon/' + item?.linkImage" alt="logo" class="w-4 h-4" />
                <div>
                    {{ item?.linkName }}
                </div>
            </div>
        </div>
        <!-- 介绍 -->
        <div class="describeContainer text-white">
            <div class="px-10 py-5"> <img src="@/assets/bottomLogo.png" alt="logo" class="w-full" /></div>
            <div class="flex flex-col gap-3 pl-10 font-extralight text-sm">
                <div>建设单位：国防科技大学</div>
                <div>支持单位：湖南强智科技发展有限公司</div>
                <div>
                    推荐使用: Chrome或Firefox等主流浏览器
                </div>
                <div>
                    Copyright © 1999- 2023 国防科技大学 版权所有
                </div>
                <div>
                网站访问次数：{{websiteVisitsNum}} 次
               </div>
              <div>
                年度访问次数：{{yearCount}} 次
              </div>
            </div>
            <div class="flex flex-col items-center py-5 gap-3">
                <img :src="'/mainsys/UserFiles/externalicon/' +info?.linkImage" alt="logo" class="w-32 h-32" />
                <div class="text-base">{{ info.linkName }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import mixins from '../hooks'

export default {
    props: {
        linkList: {
            default: () => []
        },
        info: {
            default: () => {}
        }
    },
    mixins: [mixins],
    data() {
        return {
      websiteVisitsNum:0,
          yearCount:0
        }
    },
    methods: {
    },
    mounted(){
        axios
      .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
          this.yearCount=res.data.yearCount
        }
      })
    }
};
</script>
<style scoped>
.describeContainer {
    background-image: url('~@/assets/bottomBg.jpg');
}
</style>
